import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        noun: "border-transparent bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20",
        verb: "border-transparent bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
        adjective: "border-transparent bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/20",
        adverb: "border-transparent bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/20",
        pronoun: "border-transparent bg-pink-500/10 text-pink-700 dark:text-pink-400 border-pink-500/20",
        preposition: "border-transparent bg-cyan-500/10 text-cyan-700 dark:text-cyan-400 border-cyan-500/20",
        conjunction: "border-transparent bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
        interjection: "border-transparent bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
      } as const,
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
